import React from "react";
import { Link } from "react-router-dom";
import { useState } from "react";
import "./Joblist.css";
import Breadcrumb from "../../Layout/Breadcrumb/Breadcrumb";
import Header from "../../Layout/Header/Header";
import Footer from "../../Layout/Footer/Footer";
import Nav from "../../Layout/Nav/Nav";
// import LoginImage from '../../../Images/login.jpg';
import ActionButtonCall from "../UiSpecification/ActionButton/ActionButton";
import ButtonCall from "../UiSpecification/Button/Button";

import DataTable, { createTheme } from "react-data-table-component";

function Joblist() {
  const columns = [
    {
      name: "Ref No",
      selector: (row) => row.code,
      sortable: true,
    },
    {
      name: "Date",
      selector: (row) => row.date,
      sortable: true,
    },
    {
      name: "Title",
      selector: (row) => row.title,
      // width: "720px",
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => row.status,
      // width: "720px",
      sortable: true,
    },
    {
      name: "Customer",
      selector: (row) => row.customer,
      sortable: true,
    },
    {
      name: "Technician",
      selector: (row) => row.technician,
      sortable: true,
    },
    {
      name: "Action",
      selector: (row) => row.action,
      sortable: true,
    },
  ];

  const data = [
    {
      id: 1,
      code: "J001",
      date: "12/22/24",
      title: "Checked central AC and heating system",
      status: "Open",
      customer: "Strathern Park",
      technician: "Sunil",
      // created: (
      //   <div className="tbl-created-con">
      //     <div className="tbl-created-row">Admin 01</div>
      //     <div className="tbl-created-row">2024/12/30</div>
      //   </div>
      // ),
      action: (
        <div className="icon-button-parent">
          {true ? (
            <>
              <ActionButtonCall urlto="/view-job-Accounts" btnname="view" />{" "}
              <ActionButtonCall urlto="/edit-job-Accounts" btnname="edit" />{" "}
              <ActionButtonCall btnname="disable" />
            </>
          ) : (
            <>
              <ActionButtonCall btnname="enable" />
            </>
          )}
        </div>
      ),
    },

    {
      id: 2,
      code: "J002",
      status: "Open",
      date: "10/15/24",
      title: "Decorative wall painting",
      customer: "Lorem Ipsum",
      technician: "Dignissimos Ducimus",
      // created: (
      //   <div className="tbl-created-con">
      //     <div className="tbl-created-row">Admin 01</div>
      //     <div className="tbl-created-row">2024/12/30</div>
      //   </div>
      // ),
      action: (
        <div className="icon-button-parent">
          {true ? (
            <>
              <ActionButtonCall urlto="/view-job-Accounts" btnname="view" />{" "}
              <ActionButtonCall urlto="/edit-job-Accounts" btnname="edit" />{" "}
              <ActionButtonCall btnname="disable" />
            </>
          ) : (
            <>
              <ActionButtonCall btnname="enable" />
            </>
          )}
        </div>
      ),
    },

    {
      id: 3,
      code: "J003",
      status: "Completed",
      date: "09/27/24",
      title: "Sliding door installation",
      customer: "Atque Corrupti",
      technician: "Molestias Excepturi",
      // created: (
      //   <div className="tbl-created-con">
      //     <div className="tbl-created-row">Admin 01</div>
      //     <div className="tbl-created-row">2024/12/30</div>
      //   </div>
      // ),
      action: (
        <div className="icon-button-parent">
          {true ? (
            <>
              <ActionButtonCall urlto="/view-job-Accounts" btnname="view" />{" "}
              <ActionButtonCall urlto="/edit-job-Accounts" btnname="edit" />{" "}
              <ActionButtonCall btnname="disable" />
            </>
          ) : (
            <>
              <ActionButtonCall btnname="enable" />
            </>
          )}
        </div>
      ),
    },

    {
      id: 4,
      code: "J004",
      status: "Completed",
      date: "04/18/24",
      title: "Gardens landscapers build",
      customer: "Occaecati Cupiditate",
      technician: "Deserunt Mollitia",
      // created: (
      //   <div className="tbl-created-con">
      //     <div className="tbl-created-row">Admin 01</div>
      //     <div className="tbl-created-row">2024/12/30</div>
      //   </div>
      // ),
      action: (
        <div className="icon-button-parent">
          {true ? (
            <>
              <ActionButtonCall urlto="/view-job-Accounts" btnname="view" />{" "}
              <ActionButtonCall urlto="/edit-job-Accounts" btnname="edit" />{" "}
              <ActionButtonCall btnname="disable" />
            </>
          ) : (
            <>
              <ActionButtonCall btnname="enable" />
            </>
          )}
        </div>
      ),
    },

    {
      id: 5,
      code: "J005",
      status: "Completed",
      date: "03/06/24",
      title: "Solar panel repairing",
      customer: "Laborum Dolorum",
      technician: "Expedita Distinctio",
      // created: (
      //   <div className="tbl-created-con">
      //     <div className="tbl-created-row">Admin 01</div>
      //     <div className="tbl-created-row">2024/12/30</div>
      //   </div>
      // ),
      action: (
        <div className="icon-button-parent">
          {true ? (
            <>
              <ActionButtonCall urlto="/view-job-Accounts" btnname="view" />{" "}
              <ActionButtonCall urlto="/edit-job-Accounts" btnname="edit" />{" "}
              <ActionButtonCall btnname="disable" />
            </>
          ) : (
            <>
              <ActionButtonCall btnname="enable" />
            </>
          )}
        </div>
      ),
    },
  ];

  const [records, setRecords] = useState(data);

  function handleFilter(event) {
    const newData = data.filter((row) => {
      return row.title.toLowerCase().includes(event.target.value.toLowerCase());
    });
    setRecords(newData);
  }

  return (
    <div className="page-con">
      <div className="page-nav">
        <Nav />
      </div>

      <div className="page-body">
        <Header />

        {/* <Breadcrumb/> */}

        <div className="comb-sec breadcrumb-sec">
          <div className="container-fluid px-4">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb my-0">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Home</Link>
                </li>
                <li className="breadcrumb-item">
                  <span>Job for Accounts</span>
                </li>
              </ol>
            </nav>
          </div>
        </div>

        <div className="page-content-container">
          <div className="dataTable-con">
            <div className="dataTable-serach-con dataTable-serach-con-button">
              <div className="dataTable-serach-con-button-left">
                <input
                  type="text"
                  className="dataTable-serach-input"
                  placeholder="Search"
                  onChange={handleFilter}
                />
              </div>

              <div className="dataTable-serach-con-button-right">
                {
                  <ButtonCall
                    urlto="/add-job-accounts"
                    btnname="add"
                    title="Add New Job"
                  />
                }
              </div>
            </div>

            <div className="dataTable-table-con dataTable-table-guest-list">
              <DataTable
                columns={columns}
                data={records}
                fixedHeader
                pagination
                // theme="solarized"
              />
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
}
export default Joblist;
